import logger from "loglevel";
const env = process.env.APP_ENV || "production" || "development";
const level = env !== "production" ? "debug" : "info";
logger.setLevel(level);
export default logger;